export default function autoEvent3() {
  const widgetName = 'autoEvent3';
  const widgetOpts = autoEvent3Opts;
  const wrapperClassName = 'autoEvent3-container'; // this class needs to match scss file
  const $widget = $(`#${widgetName}`);
  const showDescription = false;

  $widget.wrap(`<div class="${wrapperClassName}"></div>`);
  $widget.append('<div class="multiFeatureContent"></div>');

  $widget.MultiScheduleFeature({
    multiFeatureLoaded: function (data) {
      if (!data.length) {
        $(`.${wrapperClassName}`).remove();
        $('body').addClass('no-events-loaded');
        return;
      }
      customAutoEventFormat(data);
      $('.btn-container').appendTo($widget);
    },
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    link: ['all'],
    allEventsLink: false,
    isResponsive: false,
    lazyLoadImages: false,
    maxItemsVisible: 5,
    // allEventsLinkText: 'view full calendar',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
  });

  // ****************************************************************
  // Helpers
  function customAutoEventFormat(data) {
    $(`#${widgetName} .featureItem`).each(function (i) {
      const $cardEvent = $(this);
      const {
        Date: widgetDate,
        Name: widgetTitle,
        URL: widgetURL,
        Description: widgetDescription,
      } = data[i];

      const fixedDate = widgetDate.split('-');
      let dateLayout = '';

      if (fixedDate.length === 1) {
        const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        const dayStart = formatDate(fixedDate, 0, 0, 1);
        dateLayout = buildEventDateLayout(monthStart, dayStart);
      } else if (fixedDate.length === 2) {
        const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        const dayStart = formatDate(fixedDate, 0, 0, 1);
        const monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
        const dayEnd = formatDate(fixedDate, 1, 0, 1);
        dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
      }

      $cardEvent.empty().append(buildEventInfoLayout(widgetTitle, widgetDescription, widgetURL));

      widgetURL
        ? $cardEvent.attr('href', widgetURL)
        : $cardEvent.addClass('void').removeAttr('href');

      $cardEvent.prepend(dateLayout);
    });
  }

  function buildEventInfoLayout(title, description, url) {
    return `
      
      <div class="event-info">
        <span class="event-name">${title}</span>
        ${showDescription ? `<span class="event-description">${description}</span>` : ''}
        </div>
      ${url ? `<div class="event-arrow"></div>` : ''}  
        `;
  }

  function formatDate(date, slot1, slot2, slot3) {
    return date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  }

  function buildEventDateLayout(
    eventStartMonth,
    eventStartDay,
    eventEndMonth = null,
    eventEndDay = null,
  ) {
    if (!eventEndMonth || !eventEndDay) {
      return `
        <div class="event-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>`;
    }

    if (eventStartMonth === eventEndMonth) {
      return `
        <div class="event-date double-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}<span class="divider">-</span>${eventEndDay}</span>
        </div>`;
    }

    return `
      <div class="event-date date-range">
        <div class="combo-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>
        <span class="divider-month">-</span>
        <div class="combo-date">
          <span class="month">${eventEndMonth}</span>
          <span class="day">${eventEndDay}</span>
        </div>
      </div>`;
  }
}
